import React, { useCallback, useEffect, useState, useRef } from 'react'
import { sagaModal } from 'redux-saga-modal'
import { Form, Table, Modal, Input, Divider, Icon, Radio, Tooltip, Col, Row, Button, message, Select, Upload } from 'antd'
import styles from './styles.module.scss'
import dayjs from 'dayjs'
import * as apis from '@/apis'
const { Option } = Select;
const formItemLayout = {
  labelCol: { span: 7 },
  wrapperCol: { span: 17 },

};


const InfoDialog = (props) => {
  const { modal, isOpen, form, isEdit, rowItem = {}, ...ownProps } = props
  const { getFieldDecorator, validateFields, getFieldValue, setFieldsValue, resetFields } = form;
  const mingzi = props.type === 'staff' ? '员工' : '客服'
  const [loading, setLoading] = useState(false)
  const [managers, setManagers] = useState([]);

  const initData = async () => {
    const list = await apis.getManagers()
    setManagers(list.data || [])
  }

  const customRequest = useCallback(file => {
    if (loading) return false

    const formData = new FormData()
    formData.append('file', file)
    // formData.append('type', 'order-images')
    setLoading(true)

    apis.uploadFile(formData).then(response => {
      setFieldsValue({
        avatar: response.url
      });

    }).then(() => {
      message.success('上传成功')
    }).catch(err => {
      message.error(err.message || '图片上传失败')
    }).finally(() => setLoading(false))

    return false
  }, [loading])

  const handleSubmit = () => {

    validateFields((err, values) => {
      if (err) {
        return console.error(err)
      }
      const queryData = { ...values }
      if (isEdit) {
        queryData._id = rowItem._id
        apis.editManager(queryData).then(result => {
          message.success('提交成功')
          props.submit()
          props.submitCallback()
        }).catch(err => {
          message.error(err.message || '发生错误')
        }).finally(() => {
        })
      } else {
        apis.addManager(queryData)
          .then(result => {
            message.success('添加成功')
            resetFields()
            props.submit()
            props.submitCallback()
          }).catch(err => {
            message.error(err.message || '发生错误')
          }).finally(() => {
          })
      }
    });
  }

  useEffect(() => {
    initData()
  }, [])

  const uploadButton = (
    <Icon type="plus" style={{ fontSize: 36, color: '#D8D8D8' }} />
  );


  return (
    <Modal
      title={ownProps.title}
      destroyOnClose
      width={680}
      visible={isOpen}
      onOk={() => { handleSubmit() }}
      onCancel={props.hide}
    >
      <div>
        <Form
          {...formItemLayout}
        >
          <Row>
            <Col span={12}>
              <Form.Item
                label="姓名"
              >
                {getFieldDecorator('name', {
                  initialValue: rowItem?.user?.name,
                  rules: [
                    { required: true, message: `请输入${mingzi}姓名`, },
                  ],
                })(
                  <Input max={10} placeholder={`请输入${mingzi}姓名`} />
                )}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="手机号"
              >
                {getFieldDecorator('mobile', {
                  initialValue: rowItem.user?.mobile,
                  rules: [
                    { required: true, message: `请输入${mingzi}手机号`, },
                    { pattern: /^[1]([3-9])[0-9]{9}$/, message: '请输入正确手机号' }
                  ],
                })(
                  <Input max={11} placeholder={`请输入${mingzi}手机号`} />
                )}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="客服分组">
                {getFieldDecorator('mgroup', {
                  initialValue: rowItem.mgroup?.map(ele => ele._id),
                  rules: [
                    { required: true, message: `请选择客服分组` },
                  ],
                })(
                  <Select allowClear showArrow placeholder={`请输入${mingzi}分组`} >
                    {managers.map(ele => {
                      return <Option key={ele._id} value={ele._id}>{ele.name}</Option>
                    })
                    }
                  </Select>
                )}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="密码"
              >
                {getFieldDecorator('password', {
                  // initialValue: rowItem?.password,
                  rules: [
                    { required: (isEdit ? false : true), message: `请输入密码` },
                  ],
                })(
                  <Input.Password autoComplete="new-password" placeholder={`请输入密码`} />
                )}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="分机号"
              >
                {getFieldDecorator('ext', {
                  initialValue: rowItem?.ext,
                  rules: [
                    { message: `请输入分机号` },
                  ],
                })(
                  <Input placeholder={`请输入分机号`} />
                )}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="接单状态"
              >
                {getFieldDecorator('isWorking', {
                  initialValue: rowItem?.isWorking || true,
                  rules: [
                    { required: true, message: `请选择接单状态` },
                  ],
                })(
                  <Radio.Group>
                    <Radio value={false}>休息</Radio>
                    <Radio value={true}>接单</Radio>
                  </Radio.Group>
                )}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="是否禁用"
              >
                {getFieldDecorator('isActive', {
                  initialValue: rowItem?.isActive || true,
                  rules: [
                    { required: true, message: `请选择是否禁用` },
                  ],
                })(
                  <Radio.Group>
                    <Radio value={false}>禁用</Radio>
                    <Radio value={true}>正常</Radio>
                  </Radio.Group>
                )}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="头像"
              >
                {getFieldDecorator('avatar', {
                  initialValue: rowItem.user?.avatar,
                  valuePropName: 'fileList',
                  rules: [
                    { required: true, message: `请上传头像` },
                  ],
                })(
                  <Upload
                    listType="picture-card"
                    showUploadList={false}
                    beforeUpload={customRequest}
                    accept=".png, .jpg, .jpeg"
                  >
                    {getFieldValue('avatar') ? (
                      <img
                        src={getFieldValue('avatar')}
                        width="100"
                        alt="avatar"
                      />
                    ) : (
                      uploadButton
                    )}
                  </Upload>
                )}
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </Modal>
  )
}

export default sagaModal({
  name: 'MANAGER_DIALOG',
})(Form.create()(InfoDialog))
